import apiFetch from '../apiFetch'

export default function (userId = 0, token) {
  return apiFetch({ endPoint: `user/${userId}/Recover`, method: 'PUT', body: null, token: token })
}
